import { resolveApiBaseUrl } from './apiBaseUrl';

export const ONBOARDING_MANAGER_ROLE = 'onboarding_manager';

export function resolveStaffConsoleUrl(apiBaseUrl = resolveApiBaseUrl()) {
  return `${String(apiBaseUrl || '').replace(/\/$/, '')}/admin`;
}

export function userRoleName(user) {
  if (!user?.role) return null;
  if (typeof user.role === 'string') return user.role;
  return user.role.name || null;
}

/** Accounts that must use SQLAdmin at api.liwaza.org/admin, not the learner app. */
export function isLearnerAppBlockedUser(user) {
  return userRoleName(user) === ONBOARDING_MANAGER_ROLE;
}

export function learnerAppAccessDeniedMessage(apiBaseUrl = resolveApiBaseUrl()) {
  return `This account is for Liwaza operations only. Sign in at ${resolveStaffConsoleUrl(apiBaseUrl)}`;
}

export function redirectToStaffConsole(apiBaseUrl = resolveApiBaseUrl()) {
  if (typeof window === 'undefined') return;
  window.location.assign(resolveStaffConsoleUrl(apiBaseUrl));
}
